import { NgModule } from '@angular/core';

import { SharedModule } from '@ib-shared/shared.module';

import { SignUpWizardFooterComponent } from './components/footer/sign-up-wizard-footer.component';
import { SignUpWizardIndicatorsComponent } from './components/indicators/sign-up-wizard-indicators.component';
import { SignUpComponent } from './components/sign-up.component';
import { SignUpStepObjectiveComponent } from './components/steps/0-objective/sign-up-step-objective.component';
import { SignUpStepStartComponent } from './components/steps/1-start/sign-up-step-start.component';
import { SignUpStepAddressComponent } from './components/steps/2-address/sign-up-step-address.component';
import { SignUpStepDocsComponent } from './components/steps/3-docs/sign-up-step-docs.component';
import { SignUpStepFinishComponent } from './components/steps/4-finish/sign-up-step-finish.component';
import { SignUpStepsComponent } from './components/steps/sign-up-steps.component';
import { SignUpRoutingModule } from './sign-up-routing.module';

@NgModule({
  imports: [SharedModule, SignUpRoutingModule],
  declarations: [
    SignUpComponent,
    SignUpStepsComponent,
    SignUpStepStartComponent,
    SignUpStepAddressComponent,
    SignUpStepDocsComponent,
    SignUpStepFinishComponent,
    SignUpWizardIndicatorsComponent,
    SignUpWizardFooterComponent,
    SignUpStepObjectiveComponent,
  ],
})
export class SignUpModule {}
